'use client';

import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { T as TransNoContext } from './shared/react.31c3b5fa.mjs';
const LinguiContext = React.createContext(null);
const useLinguiInternal = devErrorMessage => {
  const context = React.useContext(LinguiContext);
  if (process.env.NODE_ENV !== "production") {
    if (context == null) {
      throw new Error(devErrorMessage !== null && devErrorMessage !== void 0 ? devErrorMessage : "useLingui hook was used without I18nProvider.");
    }
  }
  return context;
};
function useLingui() {
  return useLinguiInternal();
}
function I18nProvider(_ref) {
  let {
    i18n,
    defaultComponent,
    children
  } = _ref;
  const latestKnownLocale = React.useRef(i18n.locale);
  const makeContext = React.useCallback(() => ({
    i18n,
    defaultComponent,
    _: i18n.t.bind(i18n)
  }), [i18n, defaultComponent]);
  const [context, setContext] = React.useState(makeContext());
  React.useEffect(() => {
    const updateContext = () => {
      latestKnownLocale.current = i18n.locale;
      setContext(makeContext());
    };
    const unsubscribe = i18n.on("change", updateContext);
    if (latestKnownLocale.current !== i18n.locale) {
      updateContext();
    }
    return unsubscribe;
  }, [i18n, makeContext]);
  if (!latestKnownLocale.current) {
    process.env.NODE_ENV === "development" && console.log("I18nProvider rendered `null`. A call to `i18n.activate` needs to happen in order for translations to be activated and for the I18nProvider to render.This is not an error but an informational message logged only in development.");
    return null;
  }
  return /* @__PURE__ */React.createElement(LinguiContext.Provider, {
    value: context
  }, children);
}
function Trans(props) {
  let errMessage = void 0;
  if (process.env.NODE_ENV !== "production") {
    errMessage = "Trans component was rendered without I18nProvider.\nAttempted to render message: ".concat(props.message, " id: ").concat(props.id, ". Make sure this component is rendered inside a I18nProvider.");
  }
  const lingui = useLinguiInternal(errMessage);
  return React.createElement(TransNoContext, _objectSpread(_objectSpread({}, props), {}, {
    lingui
  }));
}
export { I18nProvider, LinguiContext, Trans, useLingui };